import React, { useState } from 'react';
interface ProductTabsProps {
  product: {
    description: string;
  };
}
export function ProductTabs({
  product
}: ProductTabsProps) {
  const [activeTab, setActiveTab] = useState('about');
  const tabs = [{
    id: 'about',
    label: 'About Product'
  }, {
    id: 'details',
    label: 'Details'
  }];
  return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-4975" data-mp="3s0tew7corjuo">
      {/* Tab Headers */}
      <div className="border-b border-gray-200" data-id="element-4976" data-mp="3d7zzsn1bt5qj">
        <div className="flex overflow-x-auto scrollbar-hide" data-id="element-4977" data-mp="3i5t41aj2jpo6">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex-shrink-0 px-6 py-4 text-sm font-medium transition-colors ${activeTab === tab.id ? 'text-[#1E2B55] border-b-2 border-[#1E2B55]' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-4978" data-mp="3460jxy21s7p6">
              {tab.label}
            </button>)}
        </div>
      </div>
      {/* Tab Content */}
      <div className="p-6" data-id="element-4979" data-mp="387pk7gfjwuw8">
        {activeTab === 'about' && <div data-id="element-4980" data-mp="348gs0g05t52s">
            <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-4981" data-mp="346m36qlrostf">
              About This Product
            </h4>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4982" data-mp="3hykaqwztygnh">
              {product.description}
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-4983" data-mp="3d226dy8ewkbo">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
              quam velit, vulputate eu pharetra nec, mattis ac neque. Duis
              vulputate commodo lectus, ac blandit elit tincidunt id. Sed
              rhoncus, tortor sed eleifend tristique, tortor mauris molestie
              elit, et lacinia ipsum quam nec dui.
            </p>
            <button className="mt-4 text-[#1E2B55] font-medium hover:underline" data-id="element-4984" data-mp="ei3dksx5vu49">
              Read More
            </button>
          </div>}
        {activeTab === 'details' && <div data-id="element-4985" data-mp="hjyg43v913hm">
            <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-4986" data-mp="hkhlym7mk1fa">
              Product Details
            </h4>
            <div className="space-y-3" data-id="element-4987" data-mp="lks1oql7y67c">
              <div className="flex" data-id="element-4988" data-mp="ljqh9vibc7cy">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-4989" data-mp="qkwadufvxwn0">
                  Brand:
                </span>
                <span className="text-sm text-gray-900" data-id="element-4990" data-mp="vjzd388e7qrt">COSRX</span>
              </div>
              <div className="flex" data-id="element-4991" data-mp="3u1v7p68c7hjf">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-4992" data-mp="3u2y05ilb5s1g">
                  Size:
                </span>
                <span className="text-sm text-gray-900" data-id="element-4993" data-mp="2sz6cpiog8wg">100ml</span>
              </div>
              <div className="flex" data-id="element-4994" data-mp="7su1545kpims">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-4995" data-mp="ckljireksi1u">
                  Skin Type:
                </span>
                <span className="text-sm text-gray-900" data-id="element-4996" data-mp="3b9u45qkmb33o">
                  All Skin Types, Dry Skin
                </span>
              </div>
              <div className="flex" data-id="element-4997" data-mp="3g7vjq1iu4kae">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-4998" data-mp="38qz21d5w2abl">
                  Key Ingredients:
                </span>
                <span className="text-sm text-gray-900" data-id="element-4999" data-mp="33rvw7qi3402k">
                  Snail Secretion Filtrate
                </span>
              </div>
              <div className="flex" data-id="element-5000" data-mp="2tt6q0uzjw425">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-5001" data-mp="2ts51bnpm3j1y">
                  Country of Origin:
                </span>
                <span className="text-sm text-gray-900" data-id="element-5002" data-mp="2pswaorpvc1am">South Korea</span>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}